import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.array.find.js";
import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters, mapActions } from 'vuex';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/heart.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/heart-full.svg';
import showNotification from '~/helpers/notification-helper';
export default {
  name: 'Heart',
  props: {
    reference: {
      type: String,
      required: true
    },
    withText: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      mdmUrls: {
        moodboard: '/user/wishlist'
      },
      loading: false
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters({
    user: 'user/me',
    items: 'wishlist/items'
  })), {}, {
    isInWishlist: function isInWishlist() {
      return this.includesRef(this.reference);
    },
    btnText: function btnText() {
      return this.isInWishlist ? this.$t('delete.btn_label') : this.$t('add.btn_label');
    }
  }),
  methods: _objectSpread(_objectSpread({}, mapActions({
    fetchWishlist: 'wishlist/fetchWishlistItems',
    addWishlistItem: 'wishlist/addWishlistItem',
    deleteWishlistItem: 'wishlist/deleteWishlistItem'
  })), {}, {
    toggleWishlist: function toggleWishlist(ref, $event) {
      if (this.loading) {
        return;
      }

      this.loading = true;

      if (this.includesRef(ref)) {
        this.removeFromWishlist(ref, $event);
      } else {
        this.addToWishlist(ref, $event);
      }
    },
    includesRef: function includesRef(ref) {
      return Boolean(this.getWishlistItem(ref));
    },
    addToWishlist: function addToWishlist(ref, $event) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this.user) {
                  _context.next = 5;
                  break;
                }

                _this.loading = false;

                _this.$root.$emit('open-layer', {
                  state: true,
                  name: 'LoginRegister'
                });

                _this.tracking({
                  ref: ref,
                  action: 'Add-to-wishlist',
                  label: 'not_connected',
                  el: $event
                });

                return _context.abrupt("return");

              case 5:
                _this.tracking({
                  ref: ref,
                  action: 'Add-to-wishlist',
                  el: $event
                });

                _context.prev = 6;
                _context.next = 9;
                return _this.addWishlistItem(ref);

              case 9:
                _context.next = 11;
                return _this.fetchWishlist();

              case 11:
                showNotification({
                  text: _this.$i18n.messages[_this.$store.state.i18n.currentLocale.language].add.subtitle,
                  destination: "/".concat(_this.$store.state.i18n.currentLocale.market, "/").concat(_this.$store.state.i18n.currentLocale.language).concat(_this.mdmUrls.moodboard),
                  backgroundColor: 'green'
                });
                _context.next = 17;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context["catch"](6);
                showNotification({
                  text: _this.$i18n.messages[_this.$store.state.i18n.currentLocale.language].add.error,
                  destination: "/".concat(_this.$store.state.i18n.currentLocale.market, "/").concat(_this.$store.state.i18n.currentLocale.language).concat(_this.mdmUrls.moodboard),
                  backgroundColor: 'red'
                });

              case 17:
                _context.prev = 17;
                _this.loading = false;
                return _context.finish(17);

              case 20:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[6, 14, 17, 20]]);
      }))();
    },
    removeFromWishlist: function removeFromWishlist(ref, $event) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var wishlistItem;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (_this2.user) {
                  _context2.next = 5;
                  break;
                }

                _this2.loading = false;

                _this2.$root.$emit('open-layer', {
                  state: true,
                  name: 'LoginRegister'
                });

                _this2.tracking({
                  ref: ref,
                  action: 'Remove-from-wishlist',
                  label: 'not_connected',
                  el: $event
                });

                return _context2.abrupt("return");

              case 5:
                _this2.tracking({
                  ref: ref,
                  action: 'Remove-from-wishlist',
                  el: $event
                });

                _context2.prev = 6;
                wishlistItem = _this2.getWishlistItem(ref);
                _context2.next = 10;
                return _this2.deleteWishlistItem(wishlistItem.reference);

              case 10:
                showNotification({
                  text: _this2.$i18n.messages[_this2.$store.state.i18n.currentLocale.language].delete.subtitle,
                  destination: "/".concat(_this2.$store.state.i18n.currentLocale.market, "/").concat(_this2.$store.state.i18n.currentLocale.language).concat(_this2.mdmUrls.moodboard),
                  backgroundColor: 'green'
                });
                _context2.next = 16;
                break;

              case 13:
                _context2.prev = 13;
                _context2.t0 = _context2["catch"](6);
                showNotification({
                  text: _this2.$i18n.messages[_this2.$store.state.i18n.currentLocale.language].delete.error,
                  destination: "/".concat(_this2.$store.state.i18n.currentLocale.market, "/").concat(_this2.$store.state.i18n.currentLocale.language).concat(_this2.mdmUrls.moodboard),
                  backgroundColor: 'red'
                });

              case 16:
                _context2.prev = 16;
                _this2.loading = false;
                return _context2.finish(16);

              case 19:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[6, 13, 16, 19]]);
      }))();
    },
    tracking: function tracking(_ref) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var ref, action, label, el, category, defaultLabel;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                ref = _ref.ref, action = _ref.action, label = _ref.label, el = _ref.el;
                category = '';

                if (window.tc_vars.env_template === 'listproduct_keyword') {
                  category = 'Search Page';
                }

                if (window.tc_vars.env_template === 'liste produits') {
                  category = 'Categorie';
                }

                if (window.tc_vars.env_template === 'page produit') {
                  category = 'FicheProduit';
                }

                defaultLabel = "".concat(window.tc_vars.page_cat1 || '', "_").concat(window.tc_vars.page_cat3 || '', "_").concat(ref);

                _this3.$root.$emit('generic-tracking', el, {
                  data: {
                    event_category: category,
                    event_action: action,
                    event_label: label || defaultLabel
                  }
                });

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    getWishlistItem: function getWishlistItem(ref) {
      return this.items && this.items.find(function (e) {
        return e.product && e.product.reference === ref;
      });
    }
  })
};